import React from "react";
import Column3D from "./NormalColumns/Column3D";
import MastColumnBeam from "./MastColumns/mastColumnBeam";
import MastColumnNone from "./MastColumns/mastColumnNone";
import MastWallBeam from "./MastWalls/mastWallBeam";
import MastWallNone from "./MastWalls/mastWallNone";

const Mast3D = ({ column, gridScale = 1, colorList, luminaires }) => {
    return (
        <>
            {(column.isMast === false || column.isMast === undefined) && (
                <Column3D
                    column={column}
                    gridScale={gridScale}
                />
            )}

            {column.isMast == true && column.values.mountingType === "wall" && (
                <>
                    {column.values.configuration == "None" && (
                        <MastWallNone
                            column={column}
                            gridScale={gridScale}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}

                    {(column.values.configuration == "Beam Aiming" || column.values.configuration == "Asymmetrical Flood Aiming") && (
                        <MastWallBeam
                            column={column}
                            gridScale={gridScale}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}

                </>
            )}
            {column.isMast == true && column.values.mountingType === "column" && (
                <>
                    {column.values.configuration == "None" && (
                        <MastColumnNone
                            column={column}
                            gridScale={gridScale}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}

                    {(column.values.configuration == "Beam Aiming" || column.values.configuration == "Asymmetrical Flood Aiming") && (
                        <MastColumnBeam
                            column={column}
                            gridScale={gridScale}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default Mast3D;
